import * as React from "react";
import { ThemeProvider, PaletteOptions, createTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { createContext, useState, useEffect } from "react";
import createTypography from "@mui/material/styles/createTypography";
import createPalette from "@mui/material/styles/createPalette";
import * as Colors from "@mui/material/colors";
//import '../../Styles/Fonts.css';
import { PaletteColorOptions, PaletteMode, useTheme } from '@mui/material';
import createCache from "@emotion/cache";
import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { CacheProvider } from "@emotion/react";
import { ApplicationState } from "../../store";

const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
})
const muiCache = createCache({
    key: 'mui',
    prepend: true,
});
function CustomThemeProvider(props: { children: any }) {
    const appLanguage = useSelector((state: ApplicationState) => state.appData?.app4legalData?.lang);
    const direction = appLanguage == "ar" ? "rtl" : "ltr";
    const { children } = props;
    // Retrieve the theme object by theme name
    const generateTheme = () =>
        createTheme({
            direction:direction , 
        });

    useEffect(() => {
        let bodyElement = document.getElementById("body") as HTMLElement;
        bodyElement?.setAttribute('dir', direction);
    }, [direction]);
    return (<CacheProvider value={direction === 'rtl' ? cacheRtl : muiCache}>
        <ThemeProvider theme={generateTheme()}>
            <div dir={direction} style={{
                height: '100%'
            }}>
                {children}
            </div>
        </ThemeProvider>
    </CacheProvider>
    );
}

export default CustomThemeProvider;